import * as types from 'redux/types/service'

export const changeSelectedProcess = selectedProcess => ({
  type: types.CHANGE_SELECTED_PROCESS,
  payload: {
    selectedProcess: selectedProcess
  }
})
